import { Suspense } from "react";
import { StyledEngineProvider } from "@mui/material/styles";

import "./providers/i18n";

import { ErrorMonitoring, LoadingFullScreen } from "@/shared/components";
import {
  ApolloProvider,
  AuthProvider,
  LocalizationProvider,
  SnackbarProvider,
  ThemeProvider,
} from "./providers";
import { Router } from "./router";

import "./index.css";

export function App() {
  return (
    <ErrorMonitoring>
      <StyledEngineProvider injectFirst>
        <ApolloProvider>
          <Suspense fallback={<LoadingFullScreen />}>
            <ThemeProvider>
              <SnackbarProvider>
                <AuthProvider>
                  <LocalizationProvider>
                    <Router />
                  </LocalizationProvider>
                </AuthProvider>
              </SnackbarProvider>
            </ThemeProvider>
          </Suspense>
        </ApolloProvider>
      </StyledEngineProvider>
    </ErrorMonitoring>
  );
}
